import type { FunctionComponent } from 'react';
import type { SvgIconProps } from '@mui/material';
import { SvgIcon } from '@mui/material';

export const ChatFavouriteIcon: FunctionComponent<SvgIconProps> = (props) => {
  const { htmlColor = '#373737' } = props;

  return (
    <SvgIcon {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          d="M13 3H11C6.02944 3 2 7.02944 2 12V17C2 19.2091 3.79086 21 6 21H13C17.9706 21 22 16.9706 22 12C22 7.02944 17.9706 3 13 3Z"
          stroke={htmlColor}
          strokeWidth="2"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 8C12.3607 8 12.6804 8.24163 12.7918 8.59851L13.3526 10.394H15.1674C15.5281 10.394 15.8477 10.6357 15.9592 10.9925C16.0707 11.3494 15.9485 11.7404 15.6567 11.9609L14.1886 13.0706L14.7494 14.8662C14.8608 15.2231 14.7387 15.614 14.4469 15.8346C14.1551 16.0551 13.76 16.0551 13.4681 15.8346L12 14.7249L10.5319 15.8346C10.24 16.0551 9.8449 16.0551 9.55308 15.8346C9.26127 15.614 9.13917 15.2231 9.25063 14.8662L9.81141 13.0706L8.34326 11.9609C8.05145 11.7404 7.92934 11.3494 8.04081 10.9925C8.15227 10.6357 8.47195 10.394 8.83265 10.394H10.6474L11.2082 8.59851C11.3196 8.24163 11.6393 8 12 8Z"
          stroke={htmlColor}
          strokeWidth="2"
          strokeLinejoin="round"
        />
      </svg>
    </SvgIcon>
  );
};

ChatFavouriteIcon.defaultProps = {
  viewBox: '0 0 24 24',
  width: '24',
  height: '24',
  fill: 'none',
};
